/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  responseTime: 0,
  isLoading: false,
  isError: false,
  msgError: '',
};

export const headcountHrRatioReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.HEADCOUNT_HR_RATIO + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.HEADCOUNT_HR_RATIO + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
      };
    case actionType.HEADCOUNT_HR_RATIO + '_FAILED':
      return {
        ...state,
        isError: true,
        isLoading: false,
        msgError: action.err,
      };
    default:
      return state;
  }
};
